import { OTHER_USER_COLOR, PENDING_BACKGROUND } from '@apartment-booking/shared';

interface CalendarLegendProps {
  userColor: string;
  userRole: 'owner' | 'admin' | 'user';
}

export default function CalendarLegend({ userColor, userRole }: CalendarLegendProps) {
  const isAdminOrOwner = userRole === 'owner' || userRole === 'admin';

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
        <span className="font-medium">Legend:</span>

        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{ backgroundColor: userColor }}
          />
          <span>Your bookings</span>
        </div>

        {isAdminOrOwner ? (
          <>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-gray-400" />
              <span>Other users</span>
            </div>
            <div className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded border-2 border-dashed border-gray-400"
                style={{ backgroundColor: PENDING_BACKGROUND }}
              />
              <span>Pending requests</span>
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded"
                style={{ backgroundColor: OTHER_USER_COLOR }}
              />
              <span>Reserved</span>
            </div>
            <div className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded"
                style={{ backgroundColor: PENDING_BACKGROUND }}
              />
              <span>Pending</span>
            </div>
          </>
        )}

        <span className="text-gray-400">|</span>

        {/* Holiday indicators */}
        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{ backgroundColor: 'rgba(139, 92, 246, 0.15)' }}
          />
          <span className="text-gray-500">Jewish holidays</span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{ backgroundColor: 'rgba(239, 68, 68, 0.12)' }}
          />
          <span className="text-gray-500">US holidays</span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{ backgroundColor: 'rgba(245, 158, 11, 0.15)' }}
          />
          <span className="text-gray-500">Events</span>
        </div>
      </div>

      <p className="text-xs text-gray-400">
        Arrival: Noon · Departure: Noon — Half-day bars indicate shared dates
      </p>
    </div>
  );
}
